module.exports = __webpack_public_path__ + "static/media/image-12.1196d419.png";